module.exports = __webpack_public_path__ + "static/media/lawdroid-voice-logo.defe66e4.png";